import ninjaApi from 'store/redux/apis/ninja.api';

export const retentionApi = ninjaApi.injectEndpoints({
  tagTypes: ['Retention'],
  /**
   * Retention API
   */
  overrideExisting: true,
  endpoints: (builder) => ({
    retentionCrmList: builder.query({
      query: (body) => ({
        url: '/retention/crm',
        method: 'POST',
        body,
      }),
      providesTags: ['Retention'],
    }),

    revenueCohort: builder.query({
      query: (body) => ({
        url: '/retention/revenue_cohort',
        method: 'POST',
        body,
      }),
      providesTags: ['Retention'],
    }),

    retentionWidgetList: builder.query({
      query: (body) => ({
        url: '/retention/widget',
        method: 'POST',
        body,
      }),
      providesTags: ['Retention'],
    }),
  }),
});

export const { useRetentionCrmListQuery, useRetentionWidgetListQuery, useRevenueCohortQuery } =
  retentionApi;
